
import { ChevronDownIcon } from 'vue-feather-icons'

export default {
    name: 'DropDown',
    components: { ChevronDownIcon },
    props: {
        name: { default: '' },
        fullWidth: { default: false },
        dialog: { default: false },
        width: { default: 100 },
        items: { default: () => ([]) },
        title: { default: '' },
        hover: { default: false, type: Boolean },
        iconHover: { default: false, type: Boolean },
        slotted: { default: false, type: Boolean },
        theme: { default: '' },
        size: { default: 'regular' },
        align: { default: '' },
        verticalAlign: { default: null },
        disabled: { default: false },
        tooltip: { default: null },
        overflow: { default: false, type: Boolean },
        arrows: { default: true, type: Boolean }
    },
    data: () => ({
        isDropdownOpen: false,
        dropdownVerticalAlign: 'bottom'
    }),
    mounted() { this.initiateDropdown() },
    beforeDestroy() {
        // Remove the scroll event listener when the component is destroyed
        window.removeEventListener("scroll", this.handleScroll);
        window.removeEventListener("resize", this.handleScroll);
    },
    methods: {
        /**
         * Initializes dropdown behavior by setting up event listeners for click, mouseleave, scroll, and resize events.
         * Ensures the dropdown hides appropriately and aligns correctly based on viewport changes.
         */
        initiateDropdown() {
            document.addEventListener('click', (e) => { if (!this.$refs.menu?.contains(e.target)) this.hideDropdown(); });
            this.$refs.menu?.addEventListener('mouseleave', () => { if (this.hover) setTimeout(this.hideDropdown, 100); });

            ['scroll', 'resize'].forEach((event) => window.addEventListener(event, this.handleScroll));

            this.handleScroll(); // Ensure alignment is correct on initialization.
        },

        /**
         * Toggles the dropdown visibility on hover based on specific conditions.
         * @param {Event} e - The hover event object.
         */
        showOnHover(e) {
            if (!this.iconHover || e.target.className === 'dropdown__toggle__icon__placeholder') this.showDropdown();
        },
        /**
         * Shows the dropdown
         */
        showDropdown() {
            this.isDropdownOpen = true
            this.$emit('show')
        },
        /**
         * Hides the dropdown
         */
        hideDropdown() {
            this.isDropdownOpen = false
            this.$emit('hide')
        },
        /**
         * Toggles the dropdown
         */
        toggleDropdown() {
            this.isDropdownOpen ? this.hideDropdown() : this.showDropdown()
        },
        /**
         * Determines dropdown vertical alignment based on its position in the viewport.
         * Aligns to 'top' if more space is above the dropdown, otherwise aligns to 'bottom'.
         */
        handleScroll() {            
            const menu = this.$refs.menu;
            if (!menu) return;

            if(this.verticalAlign) {
                this.dropdownVerticalAlign = this.verticalAlign
                return
            }

            const { top, bottom } = menu.getBoundingClientRect();
            const windowHeight = window.innerHeight || document.documentElement.clientHeight;
            
            this.dropdownVerticalAlign = top > (windowHeight - bottom) ? 'top' : 'bottom';
        }
    }
}
